import React from "react";
import ActivityTableRow from "./ActivityTableRow";

const SubheadCard = ({
  subhead,
  subheadIndex,
  deptIndex,
  scheme,
  authData,
  activity,
  formData,
  getOptions,
  handleSubheadChange,
  handleActivityChange,
  findSubActivitiesById,
  handleSubheadBudgetFormData,
  addNewActivity,
  deleteNewActivity,
  changeSubheadBudget,
}) => {
  const toNumber = (v) => {
    if (v === null || v === undefined || v === "") return 0;
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  return (
    <div className="card p-3">
      <div className="table-responsive custom-table">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th scope="col">Sub-Head Code</th>
              <th scope="col">Sub-Head Name</th>
              <th scope="col">Provisioned</th>
              <th scope="col">Released</th>
              <th scope="col">Under Approval</th>
              <th scope="col">Sanctioned</th>
              <th scope="col">Released Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr key={subheadIndex}>
              <td>
                <select
                  className="form-control"
                  name="code"
                  value={subhead.subhead_id}
                  onChange={(e) =>
                    handleSubheadChange(
                      e.target.value,
                      subheadIndex,
                      deptIndex,
                      `subhead${subheadIndex}`,
                    )
                  }
                >
                  <option value="">---Select---</option>
                  {getOptions(`subhead${subheadIndex}`, "subhead").map(
                    (option) => (
                      <option key={option.id} value={option.id}>
                        {option.code}
                      </option>
                    ),
                  )}
                </select>
              </td>
              <td>{subhead.name}</td>
              <td>{subhead.provisional_budget}</td>
              <td>{subhead.budget}</td>
              <td>{subhead.under_approval}</td>
              <td>{subhead.utilised_budget}</td>
              <td>{subhead.balance}</td>
            </tr>
            <ActivityTableRow
              subhead={subhead}
              deptIndex={deptIndex}
              subheadIndex={subheadIndex}
              scheme={scheme}
              authData={authData}
              activity={activity}
              formData={formData}
              handleActivityChange={handleActivityChange}
              findSubActivitiesById={findSubActivitiesById}
              handleSubheadBudgetFormData={handleSubheadBudgetFormData}
              addNewActivity={addNewActivity}
              deleteNewActivity={deleteNewActivity}
              changeSubheadBudget={changeSubheadBudget}
            />
          </tbody>
        </table>
      </div>
      <div className="table-responsive custom-table">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col">Provision</th>
              <th scope="col">Release Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td>Subhead Initial</td>
              <td>{toNumber(subhead.provisional_budget)}</td>
              <td>{toNumber(subhead.balance)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Total Allocation</td>
              <td>{toNumber(subhead?.allocate_provision)}</td>
              <td>{toNumber(subhead?.allocate_release)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Budget Balance</td>
              <td>
                {toNumber(subhead.provisional_budget) -
                  toNumber(subhead?.allocate_provision)}
              </td>
              <td>
                {toNumber(subhead.balance) - toNumber(subhead?.allocate_release)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubheadCard;
